var map = {
	"./Disruption Typeface/projectMeta.json": 1491,
	"./Flause Typeface/projectMeta.json": 7915,
	"./Regalia_SS01_WIP/projectMeta.json": 6596,
	"./Regalia_WIP/projectMeta.json": 9206,
	"./Tymax_Typeface/projectMeta.json": 7494
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3107;